import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { signIn, signInWithRedirect, getCurrentUser } from 'aws-amplify/auth';

import LoadingButton from "components/LoadingButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { showAlert } from "utils/Alert";
import { ReactComponent as Logo } from 'assets/images/svg/logo.svg';
import FacebookIcon from '@mui/icons-material/Facebook';

import styles from "./style.module.scss";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
} from "reactstrap";

import GoogleOAuthButton from "components/GoogleOAuthButton";
import { trackEvent } from "utils/Analytics";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES } from "utils/Constants";
import AnalyticButton from "components/AnalyticButton";
import AnalyticLink from "components/AnalyticLink";
import PasswordInput from "components/DynamicForm/components/PasswordInput";

const Login = props => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkIfUserIsLoggedIn();
  })

  const checkIfUserIsLoggedIn = async () => {
    try {
      await getCurrentUser();
      onUserLoggedIn();
    } catch (err) {
      // No current user, proceed with login
    }
  }

  const setFormValue = (fieldName, e) => {
    formData[fieldName] = e.target.value;
    setFormData(formData);
  }

  const onUserLoggedIn = () => {
    trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Success User Login")
    navigate('/dashboard');
  }

  const singIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!formData["username"] || !formData["password"]) {
      showAlert("danger", "Ingrese el email y la contraseña de su cuenta antes de continuar")
    } else {
      setLoading(true);
      const trimUserName = formData["username"].replace(/\s/g, '');
      signIn({ username: trimUserName, password: formData["password"] })
        .then(r => {
          if (r?.isSignedIn) {
            onUserLoggedIn()
          } else if (r?.nextStep?.signInStep === "CONFIRM_SIGN_UP") {
            showAlert("danger", "Por favor active su cuenta, con el enlace que se le envio por correo electronico")
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Fail Login - unactivate account")
          }
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          if (e && e.code === "UserNotConfirmedException") {
            showAlert("danger", "Por favor active su cuenta, con el enlace que se le envio por correo electronico")
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Fail Login - unactivate account")
          }
          if (e && e.code === "UserNotFoundException") {
            showAlert("danger", "No existe un usuario con el correo electrónico ingresado")
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Fail Login - no user email account")
          }
          if (e && e.code === "NotAuthorizedException") {
            let message = "Usuario y/o contraseña incorrecto";
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Fail Login - wrong password")
            if (e.message === "Password attempts exceeded") {
              message = "A excedido la cantidad maxima de intentos de inicio de sesion, por favor espere 5 minutos antes de intentar iniciar sesion nuevamente"
              trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Fail Login - user block 5 min")
            }
            showAlert("danger", message)
          }
        });
    }
  }

  const onGoogleSignInClick = () => {
    trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON, "Google Sign in")
    signInWithRedirect({ provider: 'Google' })
  }

  return (
    <>
      <div className={styles.loginContent}>
        <Container>
          <Row>
            <Col lg={{
              offset: 1,
              size: '4'
            }} md={{
              offset: 1,
              size: '7'
            }}>
              <Form action="#" onSubmit={(e) => singIn(e)} className="form" method="">
                <Card className={styles.cardLogin}>
                  <CardHeader className={styles.header}>
                    <Logo className={styles.logo} />
                  </CardHeader>
                  <CardBody>
                    <h5>Inicio de Sesion</h5>
                    <hr />
                    <FormGroup>
                      <InputGroup>
                        <InputGroupText>
                          <FontAwesomeIcon icon="fa-solid fa-envelope" />
                        </InputGroupText>
                        <Input
                          placeholder="Email"
                          type="text"
                          name="username"
                          onChange={(e) => setFormValue("username", e)} />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <PasswordInput
                        placeholder="Contraseña"
                        name="password"
                        onChange={(e) => setFormValue("password", e)}
                      />
                    </FormGroup>
                    <AnalyticLink
                      tracking={{
                        category: ANALYTIC_EVENT_CATEGORIES.USER,
                        action: ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON,
                        label: "Forgot Password"
                      }}
                      to="/auth/password-forgot">
                      Olvide mi contraseña
                    </AnalyticLink>
                    <br />
                    <br />
                    <div>
                      <LoadingButton
                        block
                        className="btn-round mb-3"
                        color="primary"
                        type="submit"
                        loading={loading}
                      >
                        Iniciar sesion
                      </LoadingButton>
                    </div>
                    {/* <div>
                      <Button
                        color="facebook"
                        block
                        className="btn-round mb-3"
                        onClick={() => signInWithRedirect({ provider: 'Facebook' })}
                      >
                        <FacebookIcon className={styles.facebookButton} />
                        Login
                      </Button>
                    </div> */}
                    <div className="text-center">
                      <GoogleOAuthButton
                        className={styles.googleButton}
                        onClick={() => onGoogleSignInClick()}
                        btnLabel="Sign in with Google">
                      </GoogleOAuthButton>
                    </div>
                  </CardBody>
                  <CardFooter>
                    <AnalyticButton
                      block
                      tracking={{
                        category: ANALYTIC_EVENT_CATEGORIES.USER,
                        action: ANALYTIC_EVENT_ACTIONS.CLICK_BUTTON,
                        label: "Go To Register"
                      }}
                      color="success"
                      onClick={() => navigate('/auth/register')}
                      className="btn btn-default btn-round"
                    >
                      Registrate
                    </AnalyticButton>
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Login;
